// @flow
import $ from 'jquery';
import { jqueryValidationOptions } from '../../forms/auto-floating-labels-form';

export const getPasswordRegex = ({
  strictPasswordValidation,
}: {
  strictPasswordValidation: boolean,
}) =>
  strictPasswordValidation
    ? /^((?=.*[a-z])(?=.*[A-Z])(?=.*?\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&''()*+,\-./:;<=>\\\\?@[\]^_`{|}~])|(?=.*[A-Z])(?=.*?\d)(?=.*[!"#$%&''()*+,\-./:;<=>\\\\?@[\]^_`{|}~])|(?=.*[a-z])(?=.*?\d)(?=.*[!"#$%&''()*+,\-./:;<=>\\\\?@[\]^_`{|}~]))([a-zA-Z0-9!"#$%&''()*+,\-./:;<=>\\\\?@[\]^_`{|}~]){14,}$/
    : /^(?=.*[a-z]|[ぁ-んァ-ン一-龯\w]).{8,24}$/;

export const getPasswordRegexMessage = ({
  strictPasswordValidation,
}: {
  strictPasswordValidation: boolean,
}) =>
  strictPasswordValidation
    ? 'パスワードは数字、大文字英字、小文字英字、記号の内3種以上を組み合わせた14文字以上の文字列を入力してください。'
    : 'パスワードは8文字以上で入力してください';

// UserPasswordClientSideValidationHelperと組み合わせて使用する
export default () => {
  const form = $('.change-password-form');
  const strictPasswordValidation = form
    .find('input[name="user[password]"]')
    .hasClass('strict-password-validation');
  form.validate({
    ...jqueryValidationOptions,
    rules: {
      'user[current_password]': {
        required: true,
      },
      'user[password]': {
        required: true,
        regex: getPasswordRegex({ strictPasswordValidation }),
      },
      'user[password_confirmation]': {
        required: true,
        equalTo: '#user_password',
      },
    },
    messages: {
      'user[current_password]': {
        required: '現在のパスワードは必須項目です。',
      },
      'user[password]': {
        required: '新しいパスワードは必須項目です。',
        regex: getPasswordRegexMessage({ strictPasswordValidation }),
      },
      'user[password_confirmation]': {
        required: '新しいパスワード(確認用)は必須項目です。 ',
        equalTo: '確認用パスワードとパスワードが一致しません。',
      },
    },
  });
};
